export default __webpack_public_path__ + "static/media/javascript.e9360603.svg";